<template>

  <div class="admin-body">
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>客服消息</el-breadcrumb-item>
        <el-breadcrumb-item>定制回复</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
    <el-row
      style="min-height: 860px; background-color: #ffffff; margin: 10px 24px; border-radius: 10px; text-align: left;">
      <el-row style="display: flex; position: relative;cursor: pointer; height: 80px;">
        <el-row style="margin: 20px 0 0 20px; display: flex;align-items: center;">
          <el-input placeholder="请输入序号或问题" v-model="input3" style="width: 400px;" class="input-with-select">
            <el-button @click="Cx()" slot="append" icon="el-icon-search">开始查询</el-button>
          </el-input>
          <el-checkbox-group v-model="checkList" style="width: 600px; margin-left: 10px;" @change="Checkbox">
            <el-checkbox label="未加音频"></el-checkbox>
            <el-checkbox label="未加图片"></el-checkbox>
            <el-checkbox label="未加链接"></el-checkbox>
           <!-- <el-checkbox label="需要加音频"></el-checkbox>
            <el-checkbox label="可加广告"></el-checkbox> -->
          </el-checkbox-group>

          <!-- <el-row style="font-size: 16px;">需要加音频（内容在60秒以内的提示），可加广告(图片和链接)。</el-row> -->
        </el-row>
        <el-row style="position: absolute; right: 60px;top: 20px; height: ;">
          <div @click="Addnewai()"
            style="padding: 10px 20px; background-color: rgba(28, 158, 251, 1); border-radius: 5px; color: #ffffff; cursor: pointer;">
            新增
          </div>
        </el-row>
      </el-row>

      <el-row style=" margin: 20px;">
        <el-table :data="tableData" style="width: 100%" :row-style="showRow">
          <el-table-column prop="auto_news_id" label="序号" width="180">
          </el-table-column>
          <el-table-column label="问题" width="180">
            <template slot-scope="scope">
              <el-popover placement="top-start" title="问题" width="300" trigger="hover" :content="scope.row.keyword">
                <div slot="reference" style="display:-webkit-box; -webkit-line-clamp:2 ;-webkit-box-orient:vertical ">
                  {{scope.row.keyword}}
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="音频内容" width="300">
            <template slot-scope="scope">
              <audio v-if="scope.row.voice" style="width: 220px;!important" ref="audio" :src="scope.row.voice"
                controls="controls">
              </audio>
              <!-- <audio controls ref="audio" class="aud" v-if="scope.row.voice">
                <source :src="scope.row.voice" />
              </audio> -->
            </template>
          </el-table-column>
          <el-table-column label="文字内容">
            <template slot-scope="scope">
              <el-popover placement="top-start" title="文字内容" width="300" trigger="hover" :content="scope.row.content">
                <div slot="reference" style="display:-webkit-box; -webkit-line-clamp:2 ;-webkit-box-orient:vertical ">
                  {{scope.row.content}}
                </div>
              </el-popover>
            </template>

          </el-table-column>
          <el-table-column prop="image" label="图片内容">
            <template slot-scope="scope" v-if="scope.row.image">
              <img :src="scope.row.image" style="width: 44px; height: 44px;" alt="">
            </template>
          </el-table-column>
          <el-table-column prop="link" label="链接内容">
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="handleClick(scope.row)" type="text" size="small">修改</el-button>
              <!-- <el-button type="text" size="small">删除</el-button> -->
              <el-popover placement="top" width="160" v-model="scope.row.Ck">
                <p>确定删除吗？</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="scope.row.Ck = false">取消</el-button>
                  <el-button type="primary" size="mini" @click="Del(scope.row.auto_news_id)">确定</el-button>
                </div>
                <el-button slot="reference" type="text" size="small" style="margin-left: 20px;"
                  @click="scope.row.Ck = true">删除</el-button>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
    </el-row>


    <el-dialog :title="txtTs" :modal="false" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <!-- <el-row style="margin: 20px 0;"></el-row> -->
      <el-row class="txt">
        <el-row style="width: 20%;"> 问题：</el-row>
        <el-input v-model="input" placeholder="请输入内容"></el-input>
      </el-row>
      <el-row class="txt">
        <el-row style="width: 20%;">音频：</el-row>
        <el-row style="text-align: left;">
          <el-upload id="audioUpload" class="avatar-uploader" name='voice' :headers="header" :action="upLoadAudio"
            :show-file-list="true" :multiple="false" :file-list="fileList" :before-remove="handleRemove" :on-remove="onremove"  :limit="1"
            :auto-upload="true" :on-change="handleChangeAudio" :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            <div slot="tip" class="el-upload__tip" style="margin-bottom: 10px">
              只能上传mp3文件，且不超过2M，播放长度不超过60s
            </div>
          </el-upload>
          <!-- <el-upload class="upload-demo" action=" http://api.txcsok.com/AutoNews/addAutoNews"
            :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove" multiple :limit="1"
            :on-exceed="handleExceed" :file-list="fileList" :auto-upload="false">
            <img src="../../assets/addNew.png" style="width: 44px; height: 44px;" alt="">

          </el-upload> -->
        </el-row>
      </el-row>
      <el-row class="txt">
        <el-row style="width: 20%;"> 文字：</el-row>
        <el-input type="textarea" :rows="10" placeholder="请输入内容" v-model="textarea">
        </el-input>
      </el-row>
      <el-row class="txt">
        <el-row style="width: 20%;"> 图片：</el-row>
        <el-row style="text-align: left;">
          <el-upload class="upload-demo" action="http://api.txcsok.com/AutoNews/addImg" name='image' :headers="header"
            :on-preview="handlePreview" :on-remove="onremove1" :before-remove="beforeRemove" multiple :limit="1"
            :on-exceed="handleExceed" :file-list="fileList1"  :on-success="successimg" :before-upload="beforeImgUpload">
            <img src="../../assets/addNew.png" style="width: 44px; height: 44px;" alt="">
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>

          </el-upload>
        </el-row>
      </el-row>
      <el-row class="txt">
        <el-row style="width: 20%;"> 链接：</el-row>
        <el-input v-model="input4" placeholder="请输入内容"></el-input>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addNew()">确 定</el-button>
      </span>

    </el-dialog>
    <el-row style="text-align: right; padding-bottom: 20px;">
      <el-pagination background layout="prev, pager, next" :total="total" :page-size="10" @current-change="CK">
      </el-pagination>
    </el-row>

  </div>
</template>

<script>
  export default {
    name: "User",
    mounted() {

    },
    data() {
      return {
        txtTs: '新增',
        visible: false,
        audioDuration: 0,
        checkList: [],
        dialogVisible: false,
        textarea: '',
        value1: '',
        input: '',
        input4: '',
        input3: '',
        select: '',
        tableData: [],
        fileList: [],
        fileList1: [],
        // [{name: 'ces.mp3', url: 'https://chat.zyyaq.com//file/2023/03/29/2023032909531422109272.mp3'}]
        upLoadAudio: 'http://api.txcsok.com/AutoNews/addVoice',
        header: {
          'fs-token': ''
        },
        total: 0,
        Getpos: {
          keyword: '',
          page: '',
          voice: '',
          image: '',
          link: '',
          pageSize: 10,

        },
        voice: '',
        image: '',
        Newtype: 0,
        new_id: 0,
        vdioSj:0
      }
    },
    computed: {

    },
    mounted() {
      this.Getlist()
      console.log(this.$store.state.login);
      this.header = {
        'fs-token': this.$store.state.login.user.jwt
      }
    },
    watch: {},
    methods: {
      Addnewai() {
        this.fileList = []
        this.fileList1 = []
        this.Newtype = 0
        this.input = ''
        this.input4 = ''
        this.textarea = ''
        this.image = ''
        this.voice = ''
        this.txtTs = '新增'
        this.dialogVisible = true
      },
      Del(id) {
        let _this = this
        this.$http.post(global.posturl.host + '/AutoNews/deleteAutoNews', {
          new_id: id
        }).then(function(response) {
          // _this.dialogVisible = false
          _this.Getlist()
          console.log(response.data)
        }).catch(function(error) {
          console.log(error)
        });
      },
      Checkbox(e) {
        console.log(e);
        let _this = this
        this.Getpos.voice = 0
        this.Getpos.image = 0
        this.Getpos.link = 0
        e.forEach((item) => {
          if (item == '未加音频') {
            _this.Getpos.voice = 1
          } else if (item == '未加图片') {
            _this.Getpos.image = 1
          } else if (item == '未加链接') {
            _this.Getpos.link = 1
          } else if (item == '可加广告') {
            _this.Getpos.link = 1
            _this.Getpos.image = 1
          }
        })
        this.Getlist()
        console.log(this.Getpos);
      },
      showRow({
        row,
        rowIndwx
      }) {
        let styleJson = {
          'height': '70px'
        }
        // if (row.show) {
        //      styleJson = {
        //          'display': 'block'
        //      }
        // } else {
        //      styleJson = {
        //          'display': 'none'
        //      }
        // }
        return styleJson // 返回对象
      },
      CK(e) {
        console.log(e);
        this.Getpos.page = e
        this.Getlist()
      },
      Cx() {
        console.log('kais ');
        this.Getpos.keyword = this.input3
        this.Getlist()
      },
      addNew() {
        let _this = this
        if (this.input == '') {
          this.$message({
            message: '请填写关键字',
            type: 'warning'
          });
          return
        }
        let obj = {
          keyword: this.input,
          image: this.image,
          voice: this.voice,
          link: this.input4,
          content: this.textarea,
          voice_time:this.vdioSj
        }
        if (this.Newtype == 0) {
          _this.$http.post(global.posturl.host + '/AutoNews/addAutoNews', obj).then(function(response) {
            _this.dialogVisible = false
            _this.Getlist()
            console.log(response.data)
          }).catch(function(error) {
            console.log(error)
          });
        } else if (this.Newtype == 1) {
          obj.new_id = _this.new_id
          _this.$http.post(global.posturl.host + '/AutoNews/editAutoNews', obj).then(function(response) {
            _this.dialogVisible = false
            _this.Getlist()
            console.log(response.data)
          }).catch(function(error) {
            console.log(error)
          });
        }


      },
      beforeAvatarUpload(file) {
        // 文件类型进行判断
        const isAudio = file.type === "audio/mp3" || file.type === "audio/mpeg";
        // 限制上传文件大小 2M
        const isLt2M = file.size / 1024 / 1024 < 2;
        this.getTimes(file);
        const isTime60S = this.audioDuration <= 60 ? true : '';
        // 获取时长
        console.log(this.audioDuration, '时间');

        if (!isAudio) {
          this.$message.error("上传文件只能是Mp3格式!");
          this.fileList = [];
        } else {
          if (!isLt2M) {
            this.$message.error("上传文件大小不能超过 2MB!");
            this.fileList = [];
          } else {
            if (!isTime60S) {
              this.$message.error("上传文件时长不能超过60秒!");
              this.fileList = [];
            }
          }
        }
        return isAudio && isLt2M && isTime60S
      },
      beforeImgUpload() {

      },
      handleChangeAudio(e) {
        console.log(e, '变化');
      },
      handleAvatarSuccess(e) {
        console.log(e, '成功');
        this.voice = e.url
      },
      getTimes(file) {
        var content = file;
        //获取录音时长
        var url = URL.createObjectURL(content);
        //经测试，发现audio也可获取视频的时长
        var audioElement = new Audio(url);

        audioElement.addEventListener("loadedmetadata", (_event) => {
          this.audioDuration = parseInt(audioElement.duration);
          console.log(this.audioDuration, '！！！！！！！！');
          this.vdioSj = this.audioDuration
        });
      },
      Getlist() {
        let _this = this
        this.$http.post(global.posturl.host + '/AutoNews/autoNewsList', this.Getpos).then(function(response) {
          _this.tableData = response.data.data
          _this.total = response.data.total
          _this.tableData.forEach((item, index) => {
            _this.$set(_this.tableData[index], 'Ck', false)
          })
          console.log(response.data)
        }).catch(function(error) {
          console.log(error)
        });
      },
      bofang1() {

        let music1 = new Audio();
        music1 = require("../../assets/ces.mp3");
        this.$refs.audio.src = music1;
        this.$refs.audio.play();

      },
      handleRemove(file, fileList) {
        // console.log(file, fileList);
        return this.$confirm(`确定删除 ${ file.name }？`);
      },
      onremove(e){
        console.log(e,'删除！',this.fileList);
        this.voice = ''
        this.fileList = []
        this.vdioSj = 0
      },
      onremove1(e){
        console.log(e,'删除！',this.fileList1);
       this.image = ''
       this.fileList1 = []
      },
      handleRemove1(file, fileList) {
        console.log(file, fileList);
      },
      handlePreview(file) {
        console.log(file);
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定删除 ${ file.name }？`);
      },
      successimg(e) {
        console.log(e);
        this.image = e.url
      },
      handleClick(row) {
        this.fileList = []
        this.fileList1 = []
        this.Newtype = 1
        console.log(row);
        // let obj = {
        //   keyword: this.input,
        //   image: [],
        //   voice: [],
        //   link: this.input4,
        //   content: this.textarea
        // }
        this.input = row.keyword
        this.input4 = row.link
        this.textarea = row.content
        this.image = row.image
        this.voice = row.voice
        this.new_id = row.auto_news_id
        this.vdioSj = row.voice_time
        if (row.voice && row.voice != '') {
          this.fileList = [{
            name: row.keyword + '.mp3',
            url: row.voice
          }]
        }
        if (row.image && row.image != '') {
          this.fileList1 = [{
            name: row.keyword + '.png',
            url: row.image
          }]
        }
        // this.fileList = [{name:row.key + '.mp3',url:row.voice}]
        // this.fileList1 = [{name:row.key + '.img',url:row.image}]
        this.txtTs = '修改'
        this.dialogVisible = true
      },
      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      }
    }
  }
</script>

<style scoped>
  .admin-body {
    /*background-color: white;*/
    width: 100%;
  }

  .main {
    background-color: white;
    min-height: 500px;
    padding: 10px;
    border: #EDEDED 1px solid;
    border-radius: 5px;
  }

  .block {
    text-align: left;
  }

  .el-select {
    width: 100%;
  }

  .hdss {
    width: 1576px;
    height: 82px;
    background-color: #ffffff;
    margin: 17px 34px;
    padding: 0px 10px;
    box-sizing: border-box;
    display: flex;
    align-items: center;

  }

  .hdss1 {
    width: 1576px;
    height: 142px;
    background-color: #ffffff;
    margin: 10px 34px;
    padding: 30px 30px;
    box-sizing: border-box;
    display: flex;
  }

  .txt {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    text-align: left;
  }

  .butt {
    font-size: 12px;
    width: 40px;
    height: 40px;
    border-radius: 10px;
    border-color: rgb(127, 204, 204);

  }

  .butt:hover {
    background: yellow;
  }
</style>



// WEBPACK FOOTER //
// src/page/user/Dzhf.vue